// var shortCutImg = 'https://statich5clover.happyelements.com/clover-web.png';
// var shareImg = 'https://statich5clover.happyelements.com/clover-web-200.png';
//var shortCutImg = 'https://ff.happyelements.com/xclover/clover-web@100.png';
var shortCutImg = 'https://statich5clover.happyelements.com/resource/clover-web@100.png';
var shareImg = 'https://statich5clover.happyelements.com/resource/clover-web-200x200-or8.png';
var desc = '全新爆爽消消乐来袭，和我一起闯关吧！不用下载就能玩';
var title = '海滨消消乐';
var appid = "106938495" //huawei appid
var SnsProxy = require("clover/sns/SnsProxy")
var sns = xClass("snsHuaweiQuickgame", SnsProxy);


sns.prototype.ctor = function() {
    this._adOff = false; // 广告功能是否关闭（配置）
    this._shareOff = false;  // 分享功能是否关闭（配置）
}

sns.prototype.initSdk = function (callback) {
    CfgManager.load("game")
    .then(()=> {
        let game = CfgManager.get("game")
        let adsOffList = game.watchad_off? game.watchad_off.split(","): [];
        let shareOffList = game.share_off? game.share_off.split(","): [];

        CfgManager.release("game");

        this._adOff = adsOffList.indexOf(XcloverPlatform.huawei) >= 0;
        this._shareOff = shareOffList.indexOf(XcloverPlatform.huawei) >= 0;

        callback();
    })
    .catch(err => {
        console.error("snsHuaweiQuickgame init failed!", err);
        callback(err? err: new Error('snsHuaweiQuickgame init failed!'));
    })

    // 华为小游戏只有versionCode>5才会生效
    system.postMessage("isShowWebPrivacy");
    console.log("[hw] postMessage isShowWebPrivacy")
    system.onmessage = function(data) {
        console.info("[hw] onmessage=", data);
        if (data.startsWith("isShowWebPrivacy@@")){
            let f = data.split("@@")[1]
            if (f == "true"){
                window._hwShowWebPrivacy = true
            }else{
                window._hwShowWebPrivacy = false
            }
        }
    }
}

//关闭友谊赛
sns.prototype.allowPvp = function() {
    return false;
}
// sns.prototype.onLoadingComplete = function () {
//     var self = this
//     var ua = navigator.userAgent.toLowerCase();
//     self.isMqq = (window.mqq && Object.keys(mqq).length)
//     if (self.isMqq) {
//         self._MqqInit();
//     }

//     //NOTE：外面有些地方根据这个判断是否播放视频
//     self.videoAd = true;
//     if (window.OPEN_DATA.qua.app != 'SQ') {
//         self.videoAd = false;
//     }
// }
sns.prototype.onLoadingCompleteInitAd = function() {
    console.log("huawei requestRewardedAd")
    let self = this

    // system.onmessage = function(data) {
    //     let result = JSON.parse(data)
    //     console.info("huawei system.onmessage onLoadingCompleteInitAd result "+ data);

    //     // if (result.errCode) {
    //     //     // console.log()
        //     self.forceCloseAd = true
    //     // }
    // }
    system.postMessage("requestRewardedAd");
    // if (this.allowAd()) {
    //     this.initAd();
    // }
}
// sns.prototype._MqqInit = function () {
//     let self = this
//     if (self.allowShare()) {
//         mqq.ui.setOnShareHandler(function (type) {
//             let textConfig = TextsManager.getInstance().getRandomTexts('default')
//             let wanbaConfig =  TextsManager.getInstance().getRandomTexts('wanba')
//             //console.log("[####]wanbaconfig:"+JSON.stringify(wanbaConfig))
//             let shareData = {
//                 title: textConfig.title,
//                 desc: textConfig.content,
//                 share_type: type,
//                 share_url: self.getShareLinkStr({ textId: textConfig.textId }),
//                 image_url: shareImg,
//                 bg_url: wanbaConfig.bg,
//                 back: true
//             }
//             //NOTE:文档表示shareArkMessage在安卓有bug，type=0表示分享到qq好友,wx只支持shareMessage
//             if (
//                 (window.OPEN_DATA.qua.app == 'QZ' || 
//                 !self.isQQIOS() || 
//                 type != 0) ||
//                 window.OPEN_DATA.qua.app == 'WX'
//                 )
//             {
//                 mqq.ui.shareMessage(shareData, function (result) {})
//             } 
//             else { // 结合版用新接口
//                 shareData.image_url = "https://qzonestyle.gtimg.cn/aoi/sola/20180328154543_HQqFkT2tYk.png"
//                 mqq.ui.shareMessage(shareData, function (result) { })
//             }
//         })

//         //设置默认分享信息
//         if (window.OPEN_DATA.qua.app == 'WX'){
//             let shareData = {
//                 title: title,
//                 desc: desc,
//                 share_type: 0,
//                 share_url: window.OPEN_DATA.shareurl + '&inviteCode=' + UserManager.getInstance().getUserRef().uid,
//                 image_url: shareImg,
//                 back: true
//             }
//             for (let i = 0; i < 4; ++i){
//                 shareData.share_type = i;
//                 mqq.ui.shareMessage(shareData)   
//             }
//         }
//     }

//     //发送快捷方式到桌面
//     window.mqq.invoke('ui', 'setOnAddShortcutHandler', {
//         'callback': mqq.callback(function () {
//             mqq.ui.addShortcut({
//                 action: 'web',
//                 title: title,
//                 icon: shortCutImg,
//                 url: window.OPEN_DATA.jumpurl + "&from=shortcut",
//                 callback: function (ret) { }
//             });
//         }, false, true)
//     })

//     //设置默认分享信息
//     if (window.OPEN_DATA.qua.app == 'WX'){
//         let shareData = {
//             title: title,
//             desc: desc,
//             share_type: 0,
//             share_url: window.OPEN_DATA.shareurl + '&inviteCode=' + UserManager.getInstance().getUserRef().uid,
//             image_url: shareImg,
//             back: true
//         }
//         for (let i = 0; i < 4; ++i){
//             shareData.share_type = i;
//             mqq.ui.shareMessage(shareData)   
//         }
//     }
// }

/**
 * type(0:qq好友 1:qq空间 2：微信好友 3：微信朋友圈)
 */
// sns.prototype.share = function (textId, platform, type, _imgUrl, _title, _desc, _link, callback, _bg) {
//     var self = this
//     if (platform == XcloverPlatform.qq || platform == XcloverPlatform.weixin) {
//         if (!window.mqq) {
//             callback({
//                 retCode: 2,
//                 data: {
//                     retCode: 2,
//                     msg: "分享未发送！"
//                 }
//             })
//             Toast.make("not share returned")
//             return
//         }

//         //给QQ好友分享内容
//         _imgUrl = _imgUrl || shareImg
//         _title = _title || title
//         _desc = _desc || desc
//         _link = _link || window.OPEN_DATA.shareurl + '&inviteCode=' + UserManager.getInstance().getUserRef().uid;

//         //分享链接加上textId
//         if (textId) {
//             _link = _link + '&textId=' + textId;
//         }

//         //NOTE:wanba force to use safe bg now
//         let wanbaConfig =  TextsManager.getInstance().getRandomTexts('wanba')
//         var shareData = {
//             title: _title,
//             desc: _desc,
//             share_type: parseInt(type),
//             share_url: _link,
//             image_url: _imgUrl,
//             bg_url: wanbaConfig.bg,
//             back: true
//         }

//         /*var a={title:"string",desc:"string",share_type:"number",share_url:"string",image_url:"string"};
//         var n
//         for(n in a){
// 			if(typeof shareData[n]!==a[n]){
//                 Toast.make("type not equal " + n + " "+(typeof shareData[n]))
// 			}
// 		}*/

//         if (window.OPEN_DATA.qua.app == 'QZ') {
//             mqq.ui.shareMessage(shareData, function (result) {
//                 if (typeof callback === "function") {
//                     try {
//                         callback(result)
//                     } catch (error) {
//                     }
//                 }
//             })
//         }
//         //微信公众号
//         else if(window.OPEN_DATA.qua.app == 'WX'){
//             for (let i = 0; i < 4; ++i){
//                 shareData.share_type = i
//                 mqq.ui.shareMessage(shareData, function (result) {
//                         //if (self.panel){
//                         //    self.panel.closePanel()
//                         //    self.panel = null
//                         //}
//                     if (typeof callback === "function") {
//                         try {
//                             callback(result)
//                         } catch (error) {
//                         }
//                     }
//                 })
//             }
//         }
//         //腾讯视频用sharemenu
//         else if (window.OPEN_DATA.qua.app == 'QQLive'){
//             mqq.ui.showShareMenu(
//             {
//                 title: _title,
//                 desc: _desc,
//                 share_url: _link,
//                 image_url: _imgUrl,
//             },
//             function(result){
//                 if (typeof callback === "function") {
//                     try {
//                         callback(result)
//                     } catch (error) {
//                     }
//                 }
//             });
//         } 
//         else { 
//             // 结合版用新接口
//             shareData.image_url = "https://qzonestyle.gtimg.cn/aoi/sola/20180328154543_HQqFkT2tYk.png"
//             mqq.ui.shareMessage(shareData, function (result) {
//                 if (typeof callback === "function") {
//                     try {
//                         callback(result)
//                     } catch (error) {
//                     }
//                 }
//             })
//         }
//         // 玩吧PC平台已经加上回调
//         // if(META.user.app == "pc") {
//         //     callback({
//         //         retCode: 0,
//         //         data: {
//         //             retCode: 0,
//         //             msg: "分享发送成功！"
//         //         }
//         //     })
//         // }
//     } else {
//         callback({
//             retCode: 2,
//             data: {
//                 retCode: 2,
//                 msg: "分享未发送！"
//             }
//         })
//     }
// }

// sns.prototype.getShareLink = function (srcapp) {
//     var self = this
//     var data = {
//         srcapp: srcapp
//     }
//     return self.getShareLinkStr(data);
// }

// sns.prototype.getShareLinkStr = function (data) {
//     data['inviteCode'] = UserManager.getInstance().getUserRef().uid;
//     var arr = [];
//     for (var name in data) {
//         var value = data[name]
//         // 手工过滤 #
//         if (!value && value !== "#") {
//             continue
//         }
//         arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
//     }
//     var suffix = arr.join("&");
//     return window.OPEN_DATA.shareurl + "&" + suffix;
// }

// sns.prototype.refresh = function () {
//     mqq.invoke("system", "refresh");
// }

// sns.prototype.getInfo = function (callback) {
//     var data = {};
//     data.ua = navigator.userAgent;
//     data.meybeQua = window.OPEN_DATA.qua.meybeQua;
//     if ((window.mqq && Object.keys(mqq).length)) {
//         //异步方式获取登录态，推荐使用此方法获取
//         window.getOpenKey(function (d) {
//             data.openData = d;
//             callback(data);
//         });
//     } else {
//         callback(data);
//     }
// }

sns.prototype.getOpenKey = function (callback) {
    let self = this
        
    system.postMessage("getOAIDAndQueryStr");
    console.log("[hw] postMessage getOAIDAndQueryStr")
    system.onmessage = function(data) {
        console.info("[hw] onmessage=", data);
        if (data.startsWith("getOAIDAndQueryStr@@")){
            window._oaid = ""
            if (data && data.startsWith("getOAIDAndQueryStr@@")){
                let temp = data.split("@@")
                if (temp[1] && temp[1].startsWith("00000000")){
                    window._oaid = "fail0"
                }else{
                    window._oaid = temp[1]
                }
                console.log("[hw] window._oaid", window._oaid)
                let queryStr = temp[2]
                console.log("[hw] queryStr", queryStr)
                let d = JSON.parse(queryStr)
                let t = null
                for (let k in d){
                    const v = d[k]
                    if (k.startsWith("thirdId") || k.startsWith("gepInfo")){
                        // 这两个不需要
                    }else{
                        if (t == null){
                            t = {}
                        }
                        t[k] = v
                        console.log("[hw] t=", JSON.stringify(t))
                    }
                }
                if (t){
                    window._ad_channel = JSON.stringify(t)
                }
                console.log("[hw] _ad_channel=", window._ad_channel)
            }
        }
    }

    HwFastappObject.onGameLoginWithRealResult = function onGameLoginWithRealResult(str) {
        console.log("onGameLoginWithRealResult", JSON.stringify(str))
        if (str.code == 0) {
            // console.log("onGameLoginResult success" + JSON.stringify(str));           
            // alert("GameLogin success" + JSON.stringify(str.data));
            callback(str.gameUserData);
        // } else if (str.code == 7004 || str.code == 2012) {
        //     //Process the game logic based on the result code.
        //     //Result code 7004 or 2012 indicates that the player has canceled the sign-in. 
        //     //In this case, the game home screen should be displayed so that the player can tap the sign-in button again.
        //     console.log("The player has canceled the sign-in. Display the home screen and let the player sign in again.")
        //     //system.postMessage("exitapp");
        // } else if (str.code == 7021) {
        //     //If result code 7021 is returned during sign-in, identity verification is canceled by the player 
        //     //in the Chinese mainland after the dialog box is displayed. In this case, you need to forbid the player from entering the game
        //     console.log("The player has canceled identity verification. Forbid the player from entering the game.")
        } else {
            // console.log("onGameLoginResult error code is " + JSON.stringify(str));
            //system.postMessage("exitapp");

            system.onmessage = function(data) {
                console.info("[hw] onmessage2=", data);
                if (data.startsWith("getOAID@@")){
                    window._oaid = ""
                    if (data && data.startsWith("getOAID@@")){
                        window._oaid = data.split("@@")[1]
                    }
                    console.log("[hw] _oaid=", window._oaid)
                }
                let result = JSON.parse(data)
                console.info("h5 showad result "+ data);
                if (result.value == "relogin") {
                    // self.forceCloseAd = true

                    var params = { 
                        "appid": appid,
                        "forceLogin": 1 
                    }
                    console.log("call gameLoginWithReal" + JSON.stringify(params));           
                    HwFastappObject.gameLoginWithReal(JSON.stringify(params));
                 }
     
            }

            if (str.code == 7004 || str.code == 2012){ //用户取消登录
                system.postMessage("tryRelogin");
            }
            // self.popBack()
        }
    }

    var params = { 
        "appid": appid,
        "forceLogin": 1 
    }
    console.log("call gameLoginWithReal" + JSON.stringify(params));           
    HwFastappObject.gameLoginWithReal(JSON.stringify(params));

}

// sns.prototype.getPlatform = function () {
//     var data = {};
//     var isMqq = (window.mqq && Object.keys(mqq).length);//是否在QQ
//     if (isMqq) {
//         data.platform = window.OPEN_DATA.platform;//2-IOS，1-安卓
//         data.pf = 'QQ';
//     }
//     return data;
// };

// sns.prototype.isQQIOS = function () {
//     var self = this
//     var data = self.getPlatform();
//     return data.pf == 'QQ' && data.platform == 2;
// }

// sns.prototype.login = function () {
    
//     var self = this
//     var isMqq = (window.mqq && Object.keys(mqq).length);//是否在QQ
//     if (isMqq) {

//         let curPf = "wanba_ts"
//         if (window.OPEN_DATA.qua.app == 'WX'||
//         (window.OPEN_DATA.qua.app == 'QQLive' && window.OPEN_DATA.loginType == 'wx')){
//             curPf = "weixin"
//             //curPf = window.OPEN_DATA.pf
//         }
//         self.getOpenKey(function (data) {
//             var params = {
//                 op: 'is_login',
//                 pf: curPf,
//                 openid: data.openid,
//                 openkey: data.openkey,
//                 serverid: window.OPEN_DATA.platform,
//             }
//             var times = 0;

//             var http = H5LoginHttp.new(true)

//             function onSuccess(event) {
//                 if (event.data.code === 0) {
//                     cc.log("openkey has renewed");
//                 } else {
//                     onFail(event);
//                 }
//             }

//             function onFail(event) {
//                 times++;
//                 if (times < 3) {
//                     http.load(params)
//                 } else {
//                     self.confirmClose();
//                 }
//             }

//             function onCancel() {

//             }

//             http.addEventListener(Events.kComplete, onSuccess)
//             http.addEventListener(Events.kError, onFail)
//             http.addEventListener(Events.kCancel, onCancel)
//             http.load(params)
//         })

//     }
// }

// sns.prototype.confirmClose = function () {

//     system.postMessage("exitapp");
//     // if (window.OPEN_DATA.qua.app == 'WX'){
//     //     console.log("[####]do not supprot showDialog in confirmclose")
//     //     return
//     // }
//     // mqq.invoke("ui", "showDialog", {
//     //     text: "您的账号已离线，请退出重进",
//     //     needOkBtn: true,
//     //     needCancelBtn: false,
//     //     okBtnText: "确定",
//     // }, function (data) {
//     //     // mqq.ui.popBack();
//     // });
// }

// sns.prototype.showDialog = function (params, okCallback, cancelCallback) {
//     if (window.OPEN_DATA.qua.app == 'WX'){
//         console.log("[####]do not supprot showDialog")
//         cancelCallback && cancelCallback()
//         return
//     }
//     var title = params.title || '';
//     var text = params.text;
//     var needOkBtn = params.needOkBtn;
//     var needCancelBtn = params.needCancelBtn;
//     var okBtnText = params.okBtnText || '确定';
//     var cancelBtnText = params.cancelBtnText || '取消';
//     mqq.invoke("ui", "showDialog", {
//         title: title,
//         text: text,
//         needOkBtn: needOkBtn,
//         needCancelBtn: needCancelBtn,
//         okBtnText: okBtnText,
//         cancelBtnText: cancelBtnText
//     }, function (data) {
//         if (data.button) {
//             cancelCallback && cancelCallback();
//         } else {
//             okCallback && okCallback();
//         }
//     });
// }

// sns.prototype.getNetworkType = function (callback) {
//     var isMqq = (window.mqq && Object.keys(mqq).length);//是否在QQ
//     if (isMqq) {
//         mqq.device.getNetworkInfo(function (result) {
//             callback(result);
//         });
//     } else {
//         callback(-1);
//     }
// }

// sns.prototype.addShortcut = function (onSuccess, onFail, onCancel) {
//     var isMqq = (window.mqq && Object.keys(mqq).length);//是否在QQ
//     if (isMqq && window.OPEN_DATA.qua.app != 'WX') {
//         mqq.ui.addShortcut({
//             action: 'web',
//             title: title,
//             icon: window.OPEN_DATA.appicon,
//             url: window.OPEN_DATA.jumpurl + "&from=shortcut",
//             callback: function (ret) {
//                 if (ret.result == 0 || ret.result == -4) {
//                     onSuccess();
//                 } else if (ret.result == -1) {
//                     onCancel('用户已取消');
//                 } else {
//                     onFail('创建失败');
//                 }
//             }
//         });
//     } else {
//         onFail('该平台不支持创建快捷方式');
//     }
// }

sns.prototype.openUrl = function (defaultTab, url, target) {
    system.postMessage("openUrl@@"+url)
}

// sns.prototype.sendGameBarMsg = function (frd, msgtype, content, onSuccess, onFail, onCancel) {
//     let self = this
//     self.getOpenKey(function (data) {
//         window.OPEN_DATA.openkey = data.openkey
//         var params = {
//             friendUids: frd,
//             msgType: msgtype,
//             content: content,
//             qua: window.OPEN_DATA.qua.meybeQua,
//             platform: window.OPEN_DATA.pf,
//             openid: data.openid,
//             openkey: data.openkey
//         }

//         var http = SendGameBarMsgHttp.new(true)

//         function onFinish() {
//             if (onSuccess) {
//                 onSuccess()
//             }
//         }

//         function onError(event) {
//             if (onFail) {
//                 onFail(event.data)
//             }
//         }

//         function onCancelled() {
//             if (onCancel) {
//                 onCancel()
//             }
//         }

//         console.log("[####]snsHuaweiQuickgame->sendGameBarMsg, platform: "+ params.platform)
//         http.addEventListener(Events.kComplete, onFinish)
//         http.addEventListener(Events.kError, onError)
//         http.addEventListener(Events.kCancel, onCancelled)
//         http.load(params)
//     })
// }

// sns.prototype.sendGift2Stranger = function (msgtype, content, src) {
//     var params = {
//         msgType: msgtype,
//         content: content,
//         src: src,
//         qua: window.OPEN_DATA.qua.meybeQua,
//         platform: window.OPEN_DATA.pf,
//         openid: window.OPEN_DATA.openid,
//         openkey: window.OPEN_DATA.openkey
//     }

//     console.log("[####]snsHuaweiQuickgame->sendGift2Stranger, platform: "+ params.platform)
//     var http = SendGift2StrangerHttp.new(true)
//     http.load(params)
// }

// sns.prototype.getWanbaGiftRewards = function (giftId, onSuccess, onFail, onCancel) {
//     var params = {
//         giftId: giftId,
//         qua: META.user.qua,
//         openid: META.user.openid,
//         openkey: META.user.openkey,
//         pf: META.user.pf
//     }

//     var http = GetWanbaGiftRewardsHttp.new(true)

//     function onFinish(event) {
//         if (onSuccess) {
//             onSuccess(event.data)
//         }
//     }

//     function onError(event) {
//         if (onFail) {
//             onFail(event)
//         }
//     }

//     function onCancelled() {
//         if (onCancel) {
//             onCancel()
//         }
//     }

//     http.addEventListener(Events.kComplete, onFinish)
//     http.addEventListener(Events.kError, onError)
//     http.addEventListener(Events.kCancel, onCancelled)
//     http.load(params)
// }

// sns.prototype.reportLogin = function () {
//     window.reportLogin();
// }

// sns.prototype.banSwipeBack = function () {
//     //关闭右滑
//     mqq.ui.setWebViewBehavior({
//         swipeBack: 0
//     })
// }

sns.prototype.popBack = function () {
    system.postMessage("exitapp");
}

// sns.prototype.setLoginInterval = function () {
//     let self = this
//     setInterval(function () {
//         self.login()
//     }, 30 * 60 * 1000);
// }

sns.prototype.onLoginFinish = function(openid, sessionid){
    console.log("[####]huawei login finish openid:"+openid+" sess:"+sessionid)
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]huawei login finish failed no openid or sessionid")
    }

}
// sns.prototype.onLoginFinish = function () {
//     if (_G.kIsNewUser && window.reportRegister) {
//         // 腾讯注册数据上报
//         window.reportRegister();
//     }
// }

//ad
/**
 * 广告是否拉取完毕可以播放
 */
sns.prototype.isAdReady = function(adPos) {
    return this.allowAd()
}

/**
 * 预加载广告
 */
sns.prototype.prepareAd = function(adPos = 0) {
    let self = this
    if (!self.allowAd()) {
        return Promise.reject({ errMsg: getText("video.ad.error") })
    } else 
        return Promise.resolve();
}

// 记录看广告
sns.prototype.finishSaveByGridAd = function(callback){
    var onSuccess = function(evt){
        if (callback){
            callback();
        }
    }
    var http = SaveShowVideoHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onSuccess);
    http.addEventListener(Events.kCancel, onSuccess);
    http.load();
    if (MetaManager.getInstance().gridAdConfig && MetaManager.getInstance().gridAdConfig.videoToday){
        MetaManager.getInstance().gridAdConfig.videoToday.push(Localhost.time());
    }
}

// 记录看金币类广告
sns.prototype.finishSaveByGoldModeAd = function(callback){
    var onSuccess = function(evt){
        if (callback){
            callback();
        }
    }
    var http = SaveGoldModeAdHttp.new();
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onSuccess);
    http.addEventListener(Events.kCancel, onSuccess);
    http.load();
}
// 记录播放广告的开始时间
sns.prototype.recordPlayADStartTime = function(){
    this.playADStartTime = new Date().getTime();
    cc.log("[AD]"," snsHuaweiQuickgame recordPlayADStartTime this.playADStartTime ",this.playADStartTime);

},
// 获取观看广告的时间（以用户最后点击关闭时间为主）
sns.prototype.getPlayADTime = function(){
    let curTime = new Date().getTime();
    let time = Math.ceil((curTime - this.playADStartTime)/1000);
    cc.log("[AD]"," snsHuaweiQuickgame getPlayADTime time ",time);
    return time;
},


/**
 * 显示广告
 * 
 */
sns.prototype.showAd = function(adPos = 0, useDefaultId = false, checkNum = -1, startShowCb,params) {
    let self = this
    if (!self.allowAd()) {
        return Promise.reject({ errMsg: getText("video.ad.error") })
    }
    if (adPos != 0){
        self.adPos = adPos
    }
    if (adPos == "AdStarDraw" || adPos == "AdStarDrawReset" || adPos == "PVPTicket") {
        adPos = 0
    }
    self.cbIndex = 0
    
    if (startShowCb){
        startShowCb();
    }
    //
    let skipAd = function() {
        Toast.make(getText("尊贵的特权玩家，已为您跳过广告啦~"))
        return Promise.resolve(true)
    }
    if (UserManager.getInstance().isHaveEquityMonthTicket()){
       return skipAd();
    }

    let buyTicketFail = function() {
        self.recordPlayADStartTime();
        DCAssist.dc4AdsShow(self.adPos,params) //广告位播放打点
        console.log("huawei showad")

        return new Promise((resolve, reject)=> {

            system.onmessage = function(data) {
                let result = JSON.parse(data)
                console.info("h5 showad result "+ data);
                if (result.errCode) {
                    // self.forceCloseAd = true
                    reject({ errMsg: getText("video.ad.error") })
                }else {
                    resolve(result.isEnded)
                }
                //  setResult(data);
                //  var adDataObject=JSON.parse(data);
                //  if(adDataObject.nativeAdData){
                //    var nativeAdList=adDataObject.nativeAdData.adList[0];
                //     if(nativeAdList){
                //         if (nativeAdList.imgUrlList) {
                //               var imgSrc=nativeAdList.imgUrlList[0];
                //               document.getElementById("adImage").src= imgSrc;
                //                console.info('ad data adImgSrc: ' +imgSrc);
                //           } 
                //     }
                //  }       
                }
            // system.postMessage("reqReportNativeAdShow");
            system.postMessage("rewardAdShow");
        })
    }

    return new Promise((resolve, reject) => {
        UserManager.getInstance().isTodayFirstShowAd().then((first)=>{
            if(first) {
                UserManager.getInstance().showTicketAd(() => {
                    skipAd().then((isEnd)=>{
                        resolve(isEnd);
                    })
                }, () => {
                    buyTicketFail().then((isEnd)=>{
                        resolve(isEnd);
                    }).catch((err)=>{
                        reject(err);
                    })
                },self.adPos);
            }else {
                resolve(buyTicketFail());
            }  
        })
    })
}

/**
 * 获取在快捷收藏里的配置名
 */
sns.prototype.getShortcutConfigName = function() {
    return "huaweiquickgame"
}
/**
 * 是否支持快捷方式进入游戏
 */
sns.prototype.supportShortcut = function() {
    return true
}

sns.prototype.getSystemPlatfrom = function () {
    return 1 //android
}


/**
 * 是否允许使用广告
 */
sns.prototype.allowAd = function() {
    let self = this
    // return true
    // console.log("huawei allowAd ", !this._adOff && !self.forceCloseAd)
    // return !this._adOff && !self.forceCloseAd
    console.log("huawei allowAd ", !this._adOff)
    return !this._adOff 
}

/**
 * 是否允许使用分享
 */
sns.prototype.allowShare = function() {
    console.log("huawei allowshare ", !this._shareOff)
    return !this._shareOff;
}

sns.prototype.showGridAd = function(config){
    console.warn("not support grid ad");
}

/**
 * 检查是否断网
 */
sns.prototype.checkNetwork = function (successCallback, failcallback) {

    // if (window.mqq && mqq.device.getNetworkType) {
    //     mqq.device.getNetworkType(
    //         function(networkType){
    //             if (networkType == 0 && failcallback){
    //                 failcallback()
    //             }else{
    //                 successCallback()
    //             }
    //         }
    //     )
    // }else{
    successCallback &&  successCallback()
    // }
}

sns.prototype.supportCustomerService = function () {
    return false
}
module.exports = sns;